import { getData, isAuth } from "actions";
import axios from "axios";
import { CardContainer, Container } from "components";
import { API_URL_notification, baseurl } from "constants/api";
import moment from "moment";
import React, { useCallback, useEffect } from "react";
import { FaTicketAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { notificationReducers } from "redux/notificationSlice";

const Notifications = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datauser = isAuth();
  const { getNotificationResult } = useSelector((state) => ({
    getNotificationResult: state.notification.getNotificationResult,
  }));

  const getNotification = useCallback(
    async (params) => {
      getData(
        API_URL_notification,
        params,
        { dispatch, redux: notificationReducers },
        "GET_NOTIFICATION"
      );
    },
    [dispatch]
  );

  const onRead = (item) => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notification/read/" + item.id + "/",
    })
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
    fetchData();
    navigate("/tickets/ticketdetail/", { state: { id: item.ticket } });
  };

  const deleteAll = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notification/readall",
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchData = useCallback(() => {
    const params = `?user_id=${datauser.user_id}`;
    getNotification(params);
  }, [getNotification]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      <CardContainer title={"View All Notifications"}>
        <div className="m-5">
          <button
            onClick={() => deleteAll()}
            className="rounded-md text-white py-1.5 w-20 bg-red-500 hover:bg-red-600 mb-4"
          >
            Delete All
          </button>

          {getNotificationResult &&
            getNotificationResult.notifications.map((item, index) => (
              <div
                key={index}
                onClick={() => onRead(item)}
                className="bg-gray-200 dark:bg-neutral-600 shadow-lg rounded-lg overflow-hidden mb-2 flex items-center hover:bg-gray-400 hover:text-white"
              >
                <FaTicketAlt className="ml-4 w-10 h-10 lg:w-15 lg:h-15 filter text-sky-600" />
                <a className="p-4">
                  <p>{item.message}</p>
                  <span>
                    {moment(item.created_at).format("DD-MM-YYYY HH:mm:ss")}
                  </span>
                </a>
              </div>
            ))}
        </div>
      </CardContainer>
    </Container>
  );
};

export default Notifications;
